import React from "react";
import PageHeaderActions from "../../../sing/components/PageHeaderActions/PageHeaderActions";

export function PriestListHeaderActions({ onCreate }: { onCreate: () => void }) {
  return (
    <PageHeaderActions>
      <div className="sing-page-actions">
        <a href="/manageCouples" className="sing-page-action-link">
          View All Couples
        </a>
        <button
          type="button"
          className="sing-page-action-link"
          onClick={onCreate}
        >
          Add Spiritual Director (Priest/Deacon)
        </button>
      </div>
    </PageHeaderActions>
  );
}
